/*
|---------------------------------------------------------
|   Pjax System Script
|---------------------------------------------------------
|
|   All pjax calls and page transitions are controlled by
|   the barba.js library.
|
|   All functionality to this system is loaded via "modules"
|   divided by sections and added to the ITM variable scope.
|
*/

/**
 * Import any modules needed here.
 */
import config from "./config";
import initScripts from "./scriptsToInitialize";
import elementor from "./elementor";
import ads from "./ads";
import socialMedia from "./socialMedia";
import wordPress from "./wordPress";
import forms from "./forms";
import podcast from "./podcast";
import audioPlayer from './audioPlayer';
import eventbrite from './eventbrite';


/**
 * Define the ITM scope or take it from the the
 * window object if already defined.
 */
var ITM = window.ITM || {};
ITM.ticker_width = '750'; //default ticker text width //WPB-3626

(function ($) {

    'use strict';

    //var $ = jQuery;

    /*
    |---------------------------------------------------------
    |   Include all imported modules into the ITM object
    |   before using them in the ITM.pjax scope.
    |
    */
    ITM.libraries = [];
    ITM.config = config;
    ITM.initScripts = initScripts;
    ITM.elementor = elementor;
    ITM.ads = ads;
    ITM.socialMedia = socialMedia;
    ITM.wordPress = wordPress;
    ITM.forms = forms;
    ITM.podcast = podcast;
    ITM.audioPlayer = audioPlayer;
    ITM.eventbrite = eventbrite;


    /*
    |---------------------------------------------------------
    |   Add all scripts inside the head tag and #barba-wrapper
    |   container in the libraries property.
    |
    */
    //$(document).on('ready', function() {

    // stop above and used this to avoid :  \'ready\' event is deprecated : WPB-4213 + WPB-3338
    $(function () {

        var libraries = jQuery(document).find('head script[src], #barba-wrapper ~ script[src]');
        // Creates an array with all scripts found
        libraries.each(function () {
            ITM.libraries.push(jQuery(this).attr('src'))
        })

        /**
         * Audio player methods
         */
        ITM.audioPlayer.flyoutBtn()
        ITM.audioPlayer.flyoutStationsBtn()

        /**
         * Add support for takeover ads
         * for non pjax calls
         */
        ITM.ads.setTakeoverAds()

        /**
         * This property enables or disables the pjax system.
         * The value of this property is set in the WordPress
         * Admin OneCMS Stream Settings page
         * @defaults integer 0
         */
        ITM.pjax.enablePjax = window.ITM_enablePjax ? window.ITM_enablePjax : 0


        /*
        |---------------------------------------------------------
        |   Initialize pjax on document ready
        |
        */
        ITM.pjax.init()

        //WPB-3626
        ITM.ticker = jQuery(document).find('.jet-text-ticker__posts');
        ITM.ticker_width = ITM.ticker.find('.slick-track').width();
        //console.log("pjax start...."+ITM.ticker_width);
    })


    /*
    |---------------------------------------------------------
    |   Set the entire functionality into the pjax scope
    |
    */
    ITM.pjax = {

        /**
         * Property to store the current page
         * content before a pjax call is triggered.
         */
        oldDocument: '',

        /**
         * Property to store the new page
         * content obtained after a pjax call
         * is triggered.
         */
        newDocument: '',


        /*
        |---------------------------------------------------------
        |   Sets all pjax default settings
        |
        */
        defaultBarba: function () {
            if (ITM.config.debug) console.log('defaultBarba');

            var pjax = this
            var originalFn = Barba.Pjax.Dom.parseResponse
            var originalCheck = Barba.Pjax.preventCheck

            /**
             * Sets the pjax wrapper ID
             */
            Barba.Pjax.Dom.wrapperId = ITM.config.wrapperId

            /**
             * Sets the pjax wrapper container class
             *
             * All content within this container will be
             * replaced on every pjax page load.
             */
            Barba.Pjax.Dom.containerClass = ITM.config.containerClass

            /**
             * Sets the class name we could could use to
             * disable pjax page loads on links.
             */
            Barba.Pjax.ignoreClassLink = ITM.config.ignoreClassLink

            /**
             *  Sets the ajax timeout value
             *
             * Use this to force the pjax process to quit after at a certain
             * time and remove the page loader.
             */
            Barba.Utils.xhrTimeout = ITM.config.timeout

            /**
             * Sets old and new documents properties
             */
            Barba.Pjax.Dom.parseResponse = function (response) {
                pjax.oldDocument = window.document
                var parser = new DOMParser()
                pjax.newDocument = parser.parseFromString(response, 'text/html')

                return originalFn.apply(Barba.Pjax.Dom, arguments)
            };

            /**
             * Disables pjax calls for certain scenarios
             */
            Barba.Pjax.preventCheck = function (evt, element) {
                if (element == null) {
                    return false
                }

                /**
                 * Sets all items that should not trigger pjax calls
                 */
                var YouCanGo = true

                jQuery(ITM.config.noPjaxItems).each(function (e, el) {
                    if (el == element)
                        YouCanGo = false
                })
                /**
                 * Disable pjax when using the elementor editor
                 */
                if (ITM.elementor.isEditor())
                    YouCanGo = false


                /**
                 * Disables pjax on login page
                 */
                if (element.attributes.href.value.indexOf('wp-login.php') !== -1)
                    YouCanGo = false


                if (!YouCanGo)
                    return YouCanGo

                return originalCheck.apply(Barba.Pjax, arguments)
            }
        },


        /*
        |---------------------------------------------------------
        |   Initializes the entire system
        |
        */
        init: function () {
            if (ITM.config.debug) console.log('init');

            var pjax = this

            /**
             * Sets all defaults
             */
            pjax.defaultBarba()

            /**
             * Add all support for forms here
             * on first load
             */
            ITM.forms.searchForms()

            /**
             * Adds pjax body classes
             */
            if (pjax.enablePjax) {
                Barba.Pjax.start()
                jQuery('body').addClass('pjax')
            } else {
                jQuery('body').addClass('no-pjax')
            }

            /**
             * Process the transition object from barba.js
             * The return of the HideShowTransition function
             * defines the process.
             */
            Barba.Pjax.getTransition = function () {
                if (ITM.config.debug) console.log('getTransition');

                ITM.ads.processAds()
                /**
                 * Close Audio player flyout tray
                 */
                ITM.audioPlayer.closeFlyout()
                ITM.audioPlayer.closeStationsFlyout()

                /**
                 * adds eventbite script for embeds
                 */
                ITM.eventbrite.appendScript()

                return pjax.HideShowTransition()
            };

            /*
            |--------------------------------------------------------
            |   All Barba Event hooks
            |
            */

            /**
             * Event Hook: on Transition Completed
             */
            Barba.Dispatcher.on('transitionCompleted', function (data) {

                if (ITM.config.debug) console.log('transitionCompleted');

                /**
                 * Process and initialize all scripts
                 */
                pjax.customJs()

                /**
                 * Adds support for Podcast Player -- WPB-3605 -- Moved before elementor.popUpSupport()
                 */
                ITM.podcast.initializePlayer()

                /**
                 * Adds support for Elementor native popUp widgets
                 */
                ITM.elementor.popUpSupport(ITM)

                /**
                 * Adds support for Breaking News widgets
                 */
                ITM.elementor.breakingNewsSupport(ITM)

                /**
                 * Resets Elementor Sticky Items
                 */
                ITM.elementor.resetStickyItems(ITM)

                /**
                 * Add all support for forms here
                 * when new content is loaded
                 */
                ITM.forms.searchForms()

                /**
                 * Add support for takeover ads
                 * for all pjax calls
                 */
                ITM.ads.setTakeoverAds()

            })

            /**
             * Event Hook: on Init State Change
             */
            Barba.Dispatcher.on('initStateChange', function (data) {
                if (ITM.config.debug) console.log("initStateChange:Data: ", data);
            })

            /**
             * Event Hook: on New Page Ready
             *
             * This is where we should run all processes
             * for the new page content
             */
            Barba.Dispatcher.on('newPageReady', function (data) {
                if (ITM.config.debug) console.log("newPageReady:Data: ", data);

                ITM.socialMedia.initFacebook()
                ITM.socialMedia.resetMetaData(ITM.pjax)
                ITM.wordPress.swapWPAdminbar(ITM.pjax)
                ITM.wordPress.swapMetaTagValue(ITM.pjax)
                /**
                 *  TODO: Only call these DFP functions when needed
                 */
                ITM.ads.swapDFPSetTarget(ITM.pjax)
                //ITM.ads.swapDFPPlayerBanner(ITM.pjax)

            })
        },

        /**
         * Use this function to filter out pjax calls
         * for special cases
         */
        AjaxPagePass: function () {
            var pjax = this
            if (jQuery(pjax.newDocument).find('body.woocommerce').length) {
                window.location.reload()
                return false
            } else {
                return true
            }
        },

        HideShowTransition: function () {
            if (ITM.config.debug) console.log('HideShowTransition');

            var pjax = this

            var transition = Barba.BaseTransition.extend({


                start: function () {

                    if (ITM.config.debug) console.log('BaseTransition start');

                    Promise
                        .all([this.newContainerLoading, this.fadeOut()])
                        .then(this.fadeIn.bind(this))

                },

                fadeOut: function () {

                    var done = false;

                    jQuery('.global-ajax-loader').fadeIn(500);

                    return done;
                },

                fadeIn: function () {
                    var _this = this

                    if (pjax.AjaxPagePass()) {

                        ITM.wordPress.swapBodyClass(pjax)
                        pjax.customCss()

                        jQuery('.' + ITM.config.containerClass).hide()

                        jQuery('html, body').scrollTop(0);

                        jQuery('.global-ajax-loader').fadeOut(500, function () {
                            jQuery('.' + ITM.config.containerClass).fadeIn(1000)
                        });

                        return _this.done();

                    }
                }
            })

            return transition

        },

        customCss: function () {
            if (ITM.config.debug) console.log('customCss');
            var pjax = this
            var oldStyleSheet = jQuery(pjax.oldDocument).find('link[rel="stylesheet"]')
            var newStyleSheet = jQuery(pjax.newDocument).find('link[rel="stylesheet"]')

            jQuery(pjax.oldDocument).find('#elementor-frontend-inline-css').remove()
            jQuery(pjax.newDocument).find('#elementor-frontend-inline-css').appendTo('head')

            oldStyleSheet.each(function (index, element) {
                if (!jQuery(pjax.newDocument).find('link[id="' + jQuery(this).attr('id') + '"]').length) {
                    jQuery(this).remove()
                }
            })

            newStyleSheet.each(function (index, element) {
                if (!jQuery(pjax.oldDocument).find('link[id="' + jQuery(this).attr('id') + '"]').length) {
                    jQuery(this).appendTo('body')
                }
            })

        },

        customJs: function () {
            if (ITM.config.debug) console.log('customJs');

            var pjax = this;
            // Container for all scripts that will need evaluation
            var playerAdDivId = jQuery("#player-emmis-ad-div-id").data("slots");
            if (ITM.config.debug) console.log("playerAdDivId:", playerAdDivId);
            var loadScript = [];
            var newScript = [];
            var supportScripts = [];

            function loadInline() {
                if (ITM.config.debug) console.log("loadInline start...");
                var counter = 1;

                jQuery('script').not('[src],[type="text/json"],[type="text/x-template"],[type="text/x-handlebars-template"],[type="text/template"],[type="application/ld+json"],[type="application/json"], [id*=' + 'tmpl-elementor' + ']').each(function () {
                    var text = jQuery(this).text()
                    counter++;

                    if (text == '') {
                        return;
                    }

                    if (text.substring(7, 12) == 'CDATA') {
                        try {
                            jQuery.globalEval(text.substring(16, text.length - 10));
                            return true
                        } catch (error) {
                            if (ITM.config.debug) console.log('loadInline CDATA Error:', error)
                        }
                    } else {
                        try {
                            if (ITM.config.debug) console.log('loadInline scripts:', text);
                            if (typeof playerAdDivId === 'undefined') {
                                jQuery.globalEval(text);
                            } else if (!text.includes(playerAdDivId)) {
                                //console.log('loadInline DFP scripts:', text);
                                jQuery.globalEval(text);
                            }
                        } catch (error) {
                            if (ITM.config.debug) console.log('loadInline script Error:', error)
                        }
                    }

                    //wPB-3224-slider size issue point 2
                    var sliderJs = 'var resized=0; setTimeout(function(){ if(jQuery(".rev_slider_wrapper").length>0 && resized==0){jQuery(window).trigger("resize"); resized=1; console.log("resizeddd..");}  }, 1000);';
                    jQuery.globalEval(sliderJs);


                }); //End of $('script').not

            } //End of function loadInline

            // Find all scripts coming from the new page
            newScript = jQuery(pjax.newDocument).find('head script[src], #barba-wrapper script[src]');
            if (ITM.config.debug) console.log('newScript:', newScript);

            // Loop thru the new page scripts found but only add new scripts found in the new pjax page
            newScript.each(function () {
                var script = jQuery(this).attr('src')
                // Compare scripts defined in libraries on first page load
                // with scripts found in the new page to only load new ones
                var found = ITM.libraries.find(function (element) {
                    return element == script
                })

                // Only add newly found scripts to the scripts array
                if (typeof found == 'undefined') {
                    loadScript.push(jQuery(this).attr('src'))
                }
            })

            if (ITM.config.debug) console.log('New page scripts found added to newScript:', loadScript);

            // Define all our support scripts needed for our services that will be loaded in the footer
            // This is because we can not load all scripts from the footer due to the amount of scripts
            supportScripts = ITM.initScripts.scripts;

            //Solve error  only one instance of babel-polyfill is allowed //widgets.listenlive.co/1.0/tdwidgets.min.js?2.0
            if (global._babelPolyfill) {
                global._babelPolyfill = false;
            }

            //WPB-4249
            var community_events_pages = false;
            if (window.location.href.indexOf("/events/community/add") != -1 || window.location.href.indexOf("/events/community/list") != -1 || window.location.href.indexOf("/events/community/edit/") != -1) {
                community_events_pages = true; //used this variable now.
            }

            /*supportScripts.forEach(function(element) {
                //loadScript.push(element)  //as usual
            });*/

            supportScripts.forEach(function (element) {
                //loadScript.push(element)  //as usual

                //------------------------------------------
                //add events page //WPB-4249
                if (element.indexOf('-new/') != -1 && community_events_pages) {
                    console.log('here events add page......................');

                    if (element.indexOf('add_events_page') != -1) {
                        loadScript.push(element);
                        //console.log(element);
                    }
                } else {
                    //console.log('here other events pages means upcomming or single event ......................');
                    if (element.indexOf('add_events_page') != -1) { //WPB-4249
                        //donot include add_events_page js !!
                        if (community_events_pages) {
                            //core files !!
                            if (element.indexOf('hoverIntent') != -1 || element.indexOf('underscore') != -1 || element.indexOf('wp-util') != -1 || element.indexOf('datepicker') != -1 || element.indexOf('sortable') != -1) {
                                loadScript.push(element);
                                console.log("here events add page 2......................");
                                console.log(element);
                            }
                        }
                    } else {
                        //console.log('here other events pages means upcomming or single event ......................');
                        //loadScript.push(element);

                        //-----------------------
                        if (element.indexOf("events_page") != -1) {

                            var chk_temp = 'list';

                            ////antebellum.onecmsdev.com/events/2021-08-02/ -- for next day
                            ////antebellum.onecmsdev.com/events/2021-08/ -- for next month
                            var tempArr = window.location.href.split('/');
                            var lastParam = tempArr[tempArr.length - 2];
                            if (lastParam) {
                                var tempArr_1 = lastParam.split('-');
                                if (tempArr_1.length == 3) {
                                    chk_temp = 'day';
                                } else if (tempArr_1.length == 2) {
                                    chk_temp = 'month';
                                }
                            }

                            //console.log(lastParam + ' >> chk_temp : '+chk_temp);

                            if (window.location.href.indexOf("/events/month") != -1 || chk_temp == 'month') {
                                if (element.indexOf("tribe-events-ajax-list") != -1 || element.indexOf("tribe-events-ajax-day") != -1) {
                                    //continue;
                                } else {
                                    loadScript.push(element);
                                }
                            } else if (window.location.href.indexOf("/events/today") != -1 || chk_temp == 'day') {
                                if (element.indexOf("tribe-events-ajax-list") != -1 || element.indexOf("tribe-events-ajax-calendar") != -1) {
                                    //continue;
                                } else {
                                    loadScript.push(element);
                                }
                            } else {
                                if (element.indexOf("tribe-events-ajax-day") != -1 || element.indexOf("tribe-events-ajax-calendar") != -1) {
                                    //continue;
                                } else {
                                    loadScript.push(element);
                                }
                            }
                        } else {
                            /*if (element.indexOf("-new/") != -1 ||  element.indexOf("the-events-calendar-filterbar/") != -1) {
                                 var tempArr = element.split('/');
                                 console.log(tempArr[tempArr.length - 1]);
                            }*/
                            loadScript.push(element);
                        }
                        //-----------------------
                    }
                }
                //------------------------------------------

            });

            if (ITM.config.debug) console.log('Support scripts plus new scripts found added to loadScript:', loadScript);

            jQuery.ajaxSetup({
                async: false
            })

            for (var i = 0; i < loadScript.length; i++) {
                // Load all scripts in the script container
                jQuery.getScript(loadScript[i])
            }

            jQuery.ajaxSetup({
                async: true
            })

            // Evaluate all inline scripts in the body
            loadInline();

            //gallery loading bug fix
            if (jQuery.isFunction(jQuery(".wpb-gallery a[rel^='prettyPhoto']").prettyPhoto)) {
                jQuery(".wpb-gallery a[rel^='prettyPhoto']").prettyPhoto({
                    animation_speed: 'normal',
                    slideshow: 3000,
                    show_title: false,
                });
            }

            if ("undefined" != typeof eventPluginActive) {
                if (eventPluginActive == 'new') {
                    if (flag_events_page == 'view_as') {
                        //no need jQuery('#tribe-bar-date').bootstrapDatepicker();  otherwise old view didnot get calendar selected as current date on pjax.
                    } else {
                        //flag_events_page == 'now_onwards'
                    }
                }
            } else {

                if (jQuery.isFunction(jQuery('#tribe-bar-date').bootstrapDatepicker)) {
                    jQuery('#tribe-bar-date').bootstrapDatepicker(); // date picker event
                }

            }

            //event add page.
            /*if (jQuery.isFunction(jQuery('#EventStartDate').bootstrapDatepicker)) {
                jQuery('#EventStartDate').bootstrapDatepicker();
                jQuery('#EventEndDate').bootstrapDatepicker();
            }*/

            //upcomming /events page.
            //var $container=jQuery('.tribe-events-c-top-bar__datepicker-container');
            //var $input = $container.find('[data-js="tribe-events-top-bar-date"]');
            //$input.bootstrapDatepicker(); //not working.....
            //$container.bootstrapDatepicker(); //this may works but just checking.
        }

    }
})(jQuery)
